/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PlayDouble from './play-double-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PlayDouble {...validProps} />;
}
SvgComponent.iconName = 'play-double-icon';

export const PlayDoubleIcon = svgIconWrapper(SvgComponent);
